import { ApprovalIndicationState, ApprovalIndicationContent } from '../types/approved.types';
import { createSlice } from '@reduxjs/toolkit';

const initialState: ApprovalIndicationState = {
    content: [],
    selected: null,
    totalPages: null,
    fdaId: null,
    fdaData: null,
};

const approvedSlice = createSlice({
    name: 'approvedIndication',
    initialState: initialState,
    reducers: {
        updateFdaData: (state: ApprovalIndicationState, action: { payload: ApprovalIndicationState }) => {
            state.content = action.payload.content;
            state.totalPages = action.payload.totalPages;
        },
        updateFDAListByPage: (state: ApprovalIndicationState, action: { payload: ApprovalIndicationState }) => {
            state.content = action.payload.content;
            state.totalPages = action.payload.totalPages;
        },
        updateSelectedFda: (state : ApprovalIndicationState, action : {payload : ApprovalIndicationContent}) => {
            state.selected = action.payload;
        },
        resetSelectedFda: (state) => {
            state.selected = null;
        },
        updateCreateFda: (state, action) => {
            state.fdaId = action.payload.id;
        },
        getAllFdaAction: (state, _action) => {return state},
        getAllFDAActionByPage: (state, _action) => {return state},
        getSingleFdaAction: (state, _action) => {return state},
        createFdaAction: (state, _action) => {return state},
        updateFdaAction: (state, _action) => {return state},
        deleteFdaAction: (state, _action) => {return state},
        patchToggleUpdateDisableActionFda: () => {return },
        patchToggleUpdateEnableActionFda: () => {return },
        patchToggleUpdateBulkDisableActionFda: () => {return },
        patchToggleUpdateBulkEnableActionFda: () => { return},
    },
});

export const {
    updateFdaData,
    getAllFdaAction,
    getAllFDAActionByPage,
    getSingleFdaAction,
    updateFdaAction,
    updateFDAListByPage,
    updateSelectedFda,
    // updateFdaId,
    updateCreateFda,
    createFdaAction,
    resetSelectedFda,
    deleteFdaAction,
    patchToggleUpdateDisableActionFda,
    patchToggleUpdateEnableActionFda,
    patchToggleUpdateBulkDisableActionFda,
    patchToggleUpdateBulkEnableActionFda,
} = approvedSlice.actions;
export default approvedSlice.reducer;
